module.exports = __webpack_public_path__ + "static/media/Oxygen-BoldItalic.3b893b55.otf";